import Container from "@mui/material/Container";
import {} from "./App.css";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/loginpage";
import { useSelector } from "react-redux";
import React from "react";
import HeaderMenu from "./components/HeaderMenu";
import NewDashboard from "./pages/newDashboard";
import Inventory from "./pages/inventory";
// import {useDispatch} from 'react-redux';
// import sktrDetailsSlice from '../redux/sktrSlice';
function App() {
  let loggedIn = useSelector((state) => {
    return state.sktr.loggedIn;
  });

  // Header Navigation options
  const headerNav = [
    {
      id: "trackables",
      title: "Trackables",
      path: "/trackables",
      children: [
        {
          id: "dashboard",
          title: "Dashboard",
          path: "/dashboard",
        },
        {
          id: "inventory",
          title: "Inventory",
          path: "/inventory",
        },
        {
          id: "assets",
          title: "Assets",
          path: "/assets",
        },
        {
          id: "asset_groups",
          title: "Asset Groups",
          path: "/asset_groups",
        },
        {
          id: "asset_types",
          title: "Asset Types",
          path: "/asset_types",
        },
        {
          id: "devices",
          title: "Devices",
          path: "/devices",
        },
      ],
    },
    {
      id: "stating",
      title: "Stating",
      path: "/stating",
      children: [], // no children
    },
    {
      id: "geozones",
      title: "GeoZones",
      path: "/geozones",
      children: [
        {
          id: "geozones_1",
          title: "GeoZones1",
          path: "/geozones_1",
        },
        {
          id: "geozones_2",
          title: "GeoZones2",
          path: "/geozones_2",
        },
      ], // no children
    },
    {
      id: "alerts",
      title: "Alerts",
      path: "/alerts",
      children: [
        {
          id: "alerts1",
          title: "Alerts 1",
          path: "/alerts1",
        },
      ], // no children
    },
  ];
  //AUTH TOKEN
  const itemStr = JSON.parse(localStorage.getItem("authToken"));
  if (itemStr !== null) {
    if (new Date().getTime() > itemStr.expiry) {
      localStorage.removeItem("authToken");
    } else {
      loggedIn = true;
    }
  }

  if (!loggedIn) {
    return (
      <React.Fragment>
        <Container fixed>
          <LoginPage />
        </Container>
      </React.Fragment>
    );
  }

  return (
    <div className="admin_sktr">
      <Container class="container_full_length">
        <HeaderMenu paths={headerNav} />
      </Container>
      <Routes>
        <Route path="/" element={<NewDashboard />} />
        <Route path="/trackables/dashboard" element={<NewDashboard />} />
        <Route path="/trackables/inventory" element={<Inventory />} />
      </Routes>
    </div>
  );
}

export default App;
